module.exports = __webpack_public_path__ + "static/media/create.837bebc7.jpeg";